
<div class="container" >
    <br>
<mat-drawer-container class="draw-container panel-container" autosize>
<mat-drawer mode="side" opened position="start" class="options-menu">
    <mat-nav-list>
        <a mat-list-item routerLink="datos-personales" routerLinkActive="active">
            <mat-icon matListItemIcon>badge</mat-icon>
            <span matListItemTitle class="ocultar-opcion">Datos personales</span>      
        </a>
        <a mat-list-item routerLink="cambio-contrasena" routerLinkActive="active">
            <mat-icon matListItemIcon>password</mat-icon>
            <span matListItemTitle class="ocultar-opcion">Cambiar contrase&ntilde;a</span>      
        </a>
        <a mat-list-item routerLink="firma-electronica" routerLinkActive="active">
            <mat-icon matListItemIcon><span class="material-symbols-outlined">signature</span></mat-icon>
            <span matListItemTitle class="ocultar-opcion">Firma electr&oacute;nica</span>      
        </a>
        <a mat-list-item routerLink="lista-envio" routerLinkActive="active">
            <mat-icon matListItemIcon>format_list_bulleted</mat-icon>
            <span matListItemTitle class="ocultar-opcion">Lista de env&iacute;o</span>
        </a>
        <a mat-list-item routerLink="buzon" routerLinkActive="active">
            <mat-icon matListItemIcon><span class="material-symbols-outlined">markunread_mailbox</span></mat-icon>
            <span matListItemTitle>Buz&oacute;n</span>
        </a>

        @if (hasAdminRole) {
        <a mat-list-item routerLink="parametros-configuracion" routerLinkActive="active" style="padding-right:0px">
            <mat-icon matListItemIcon>settings</mat-icon>
            <span matListItemTitle class="ocultar-opcion">Par&aacute;metros</span>      
        </a>
        <a mat-list-item routerLink="tipos-documentos" routerLinkActive="active">
            <mat-icon matListItemIcon>difference</mat-icon>
            <span matListItemTitle class="ocultar-opcion">Tipos documentos</span>      
        </a>
        <a mat-list-item routerLink="plantillas-memos" routerLinkActive="active">
            <mat-icon matListItemIcon><span class="material-symbols-outlined">
                    clarify
                </span></mat-icon>
            <span matListItemTitle class="ocultar-opcion">Plantillas</span>      
        </a>
        <a mat-list-item routerLink="tramite-abreviaciones" routerLinkActive="active">
            <mat-icon matListItemIcon>format_list_numbered_rtl</mat-icon>
            <span matListItemTitle class="ocultar-opcion">Num. documento</span>      
        </a>
        <a mat-list-item routerLink="reasignacion" routerLinkActive="active">
            <mat-icon matListItemIcon><span class="material-symbols-outlined">
                    supervisor_account
                </span></mat-icon>
            <span matListItemTitle class="ocultar-opcion">Reasignar</span>      
        </a>
        <a mat-list-item routerLink="reasignacion-masiva" routerLinkActive="active">
            <mat-icon matListItemIcon><span class="material-symbols-outlined">
                    social_distance
                </span></mat-icon>
            <span matListItemTitle class="ocultar-opcion">Reasignaci&oacute;n masiva</span>
        </a>

        }
    </mat-nav-list>
    
</mat-drawer>
  <mat-drawer-content>
    <router-outlet    
    ></router-outlet>
  </mat-drawer-content>
</mat-drawer-container>
</div>